class UserActivitySummaryViewModel {
  uid;
  average_bet;
  average_poker_buy_in;
  casino_favorite_games;
  days_from_last_active;
  last_played_game;
  poker_favorite_games;
  skill_flag;
  slot_favorite_games;
}
export {
  UserActivitySummaryViewModel
};
//# sourceMappingURL=types.js.map
